import { Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-identialert-sub-selection-modal',
  templateUrl: './identialert-sub-selection-modal.component.html',
  styleUrls: ['./identialert-sub-selection-modal.component.scss']
})
export class IdentialertSubSelectionModalComponent {
  @Input('modalRef') public modalRef: NgbModalRef;
  @Input() public isUpgrade: boolean;

  public loading = false;
  public pricingPlans = environment.stripePlans;
  public planIdIdentiAlert = this.pricingPlans.identiAlertAnnual;

  constructor(
    private _checkoutService: CheckoutService,
    private _logService: LogService
  ) { }

  public onCloseModal() {
    this.modalRef.close();
  }

  public onSubscribeToIdentiAlert() {
    this.loading = true;

    this._checkoutService
    .checkout(
      [this.planIdIdentiAlert],
      { isUpgrade: this.isUpgrade }
    ).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      err => {
        this._logService.error('an error occured: ', err);
      }
    )
    .add(() => {
      this.loading = false;
      this.modalRef.close();
    });
  }

}
